import { type ReactElement } from 'react'
import { getInitialism, getName, type TinyUser, type UserId } from '@terros/common'
import { type GetHookResponse, useTinyUser, useTinyUserByIdentifier } from '@front/model'
import { AvatarBlurhash } from '../AvatarBlurhash'
import { detectIdAndGetUrl } from './util'
import { DetectedIdAction, type DetectedIdActionProps } from './DetectedIdAction'

export const UserIdItem = ({ userId, ...props }: DetectedIdActionProps & { userId: UserId }): ReactElement => {
  const query = useTinyUser(userId)
  return <UserLookupItem {...props} query={query} />
}

export const UserEmailItem = ({ email, ...props }: DetectedIdActionProps & { email: string }): ReactElement => {
  const query = useTinyUserByIdentifier(email)
  return <UserLookupItem {...props} query={query} />
}

const UserLookupItem = ({
  query,
  ...props
}: DetectedIdActionProps & { query: GetHookResponse<TinyUser> }): ReactElement => {
  const name = query.data ? getName(query.data) : undefined
  const detected = query.data ? (detectIdAndGetUrl(query.data.userId) ?? props.detected) : props.detected
  return (
    <DetectedIdAction
      {...props}
      detected={detected}
      query={query}
      name={name}
      leftSection={
        <AvatarBlurhash
          avatarUrl={query.data?.avatarUrl}
          avatarBlurhash={query.data?.avatarBlurhash}
          color={query.data?.color}
          initials={getInitialism(name ?? '')}
          size={36}
          radius='50%'
        />
      }
      icon='person'
    />
  )
}
